.play-pause-icon {
  --size: 32px;
  color: var(--ui-color-white, #fff);
  width: 100%;
  display: inline-block;
  height: 100%;
  max-height: var(--size);
  max-width: var(--size);
}
